import Image from "next/image";
import { useState, useRef } from "react";

const Slider = ({
  children,
  contentsDiv,
  move,
  entireWidth,
  fixWidth,
  movePX,
  data,
  moveLeft,
  moveRight,
}: {
  children: React.ReactNode;
  contentsDiv: React.RefObject<HTMLDivElement>;
  move: number;
  entireWidth: number;
  fixWidth: number;
  movePX: number;
  data: any[];
  moveLeft: () => void;
  moveRight: () => void;
}) => {
  return (
    <div className="relative ">
      <div className="overflow-hidden">
        <div
          ref={contentsDiv}
          className={`flex gap-4 p-6 w-fit ${
            move === 0 ? "pl-[1.25rem]" : ""
          } w-fit flex justify-start   overflow-x-auto scroll !items-stretch `}
          style={
            data?.length < 3
              ? {}
              : {
                  transition: "all .2s ease .2s",
                  transform: `translate(${
                    entireWidth - (movePX * (move - 1) + fixWidth) <= movePX
                      ? -movePX * (move - 1) -
                        (entireWidth - (movePX * (move - 1) + fixWidth) + 20)
                      : -movePX * move
                  }px)`,
                }
          }
        >
          {children}
        </div>
      </div>
      <div
        onClick={() => {
          moveLeft();
        }}
        className={`${
          move === 0 && "hidden"
        }  cursor-pointer absolute z-[2] left-0 top-[50%] translate-y-[-50%] translate-x-[-50%] w-[32px] h-[32px] p-2 bg-white rounded-[50px] shadow justify-start`}
      >
        <Image
          height={30}
          width={30}
          alt="left-btn"
          src={"/images/icons/main/leftArrow.svg"}
        />
      </div>
      <div
        onClick={() => {
          moveRight();
        }}
        className={`${
          (movePX * move + fixWidth >= entireWidth || data?.length < 3) &&
          "hidden"
        }   cursor-pointer absolute z-[2] right-0 top-[50%] translate-y-[-50%] translate-x-[50%] w-[32px] h-[32px] p-2 bg-white rounded-[50px] shadow justify-start`}
      >
        <Image
          height={30}
          width={30}
          alt="left-btn"
          src={"/images/icons/main/rightArrow.svg"}
        />
      </div>
    </div>
  );
};

const useDesktopSlider = (data: any[]) => {
  //데스크탑 캐러샐

  const [move, setMove] = useState(0);
  const contentsDiv = useRef<HTMLDivElement>(null);
  const entireWidth = contentsDiv.current?.clientWidth as number;
  const fixWidth = 800;
  const movePX = 450;
  const moveRight = () => {
    if (entireWidth <= movePX * move) {
      return;
    }
    setMove((prev) => prev + 1);
  };
  const moveLeft = () => {
    if (move != 0) {
      setMove((prev) => prev - 1);
    }
  };

  return {
    Slider,
    sliderProps: {
      move,
      contentsDiv,
      entireWidth,
      fixWidth,
      movePX,
      data,
      moveLeft,
      moveRight,
    },
  };
};
export default useDesktopSlider;
